import EditableText from "./EditableText";

const FOUNDER_BG =
  "https://static.prod-images.emergentagent.com/jobs/a2630fa8-7512-4afc-8f34-38ff2529270f/images/82fc11d4ec77c9ae9dfe303f72d7047611f0d87b544b815b4dfba0e07078295f.png";
const FOUNDER_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_feminineways-notify/artifacts/4kubo5my_Charlotte%20Bryan%20-%20Founder%20FeminineWays.png";

export const FounderNote = () => {
  return (
    <section id="founder" data-testid="founder-section" className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#EADDFF]/60 grain overflow-hidden">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
            <img src={FOUNDER_PORTRAIT} alt="Charlotte Bryan, founder of Feminine Ways" className="w-full h-full object-cover object-[center_30%]" data-testid="founder-portrait" />
          </div>
          <div className="absolute -bottom-8 -right-4 sm:-right-8 w-40 sm:w-52 aspect-[4/3] rounded-2xl overflow-hidden border-8 border-[#F4ECFF] shadow-xl hidden sm:block">
            <img src={FOUNDER_BG} alt="Notebook and mug — quiet morning ritual" className="w-full h-full object-cover" data-testid="founder-stilllife" />
          </div>
        </div>

        <div className="lg:col-span-7">
          <EditableText k="founder.eyebrow" fallback="By a woman · For women" className="eyebrow" data-testid="founder-eyebrow" />
          <blockquote className="mt-6">
            <p className="editorial-display text-3xl sm:text-4xl lg:text-5xl text-[#0B0A4A] leading-[1.1]" data-testid="founder-quote">
              "<EditableText
                k="founder.quote"
                fallback="I was sick of using multiple tools and trying to guess and see how they fit together. I wanted one tool to do it all."
                multiline
              />"
            </p>
            <footer className="mt-8 flex items-center gap-4" data-testid="founder-byline">
              <div className="w-12 h-px bg-[#3E1A7A]" />
              <div>
                <EditableText k="founder.name" fallback="Charlotte Bryan" as="p" className="font-serif text-xl text-[#0B0A4A] leading-tight" />
                <EditableText k="founder.role" fallback="Founder, Feminine Ways" as="p" className="text-xs uppercase tracking-[0.25em] text-[#3E1A7A] mt-1" />
              </div>
            </footer>
          </blockquote>

          <p className="mt-10 font-sans text-base sm:text-lg text-[#0B0A4A]/80 max-w-xl leading-relaxed">
            <EditableText
              k="founder.intro"
              fallback="Built by a woman, for women. Feminine Ways was born from one woman's quiet frustration that wellness for the female body had been pieced together from apps designed for men. So Charlotte built the one she always wanted — designed around female physiology from the very first line of code."
              multiline
            />
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
